import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from '../tokens/api.token';
import { AuthService } from './auth.service';

export interface FeedbackPayload {
  message: string;
  module?: string;
  route_path?: string;
}

@Injectable({
  providedIn: 'root',
})
export class FeedbackService {
  private http = inject(HttpClient);
  private auth = inject(AuthService);

  // Utilizes the shared API_URL token with the same production fallback
  private baseApiUrl = inject(API_URL, { optional: true }) ?? 'https://api.suitelifetools.com';
  private apiUrl = `${this.baseApiUrl}/feedback`;

  submitFeedback(payload: FeedbackPayload): Observable<any> {
    const user = this.auth.currentUser();

    const body = {
      sub: user?.id || null,
      message: payload.message,
      module: payload.module || 'unknown',
      route_path: payload.route_path || window.location.pathname,
    };

    return this.http.post(this.apiUrl, body);
  }
}
